import React from 'react';
import BaseComponent from '../baseComponent';
import styles from './productfinderresultpage.scss';
import IProductFinderResultPage from './productfinderresultpage.d';
import PfArticleTileGrid from './pfArticleTileGrid/pfArticleTileGrid';
import PfStickyHeader from './pfStickyHeader/pfStickyHeader';
import PfStickyHeaderMobile from './pfStickyHeader/pfStickyHeaderMobile';
import FragmentPlaceholder from '../../Common/fragment-placeholder/fragment-placeholder';
import MainSidePanel from '../mainSidePanel/mainSidePanel';
import ArticleTileContextProvider from '../globalState/articleTileContext';

export default class ProductFinderResultPage extends BaseComponent<IProductFinderResultPage, {}> {
    private gridRef = React.createRef<HTMLDivElement>();

    constructor(props: IProductFinderResultPage) {
        super(props);
    }

    componentDidMount(): void {
        super.componentDidMount();
    }

    public render() {
        const { scoredProducts, isMobile, isGlobal, viewType,
            finderType, priceMode, isEsApp } = this.props.productFinderPageProps;

        const isNewsLetterVisible = !isMobile && scoredProducts.length > 4;

        return (
            <ArticleTileContextProvider l10n={this.props.l10n} cdnUrl={this.props.productFinderPageProps.cdnUrl}>
                <div className={styles.productfinderresultpage}>
                    <MainSidePanel
                        shouldShowProductFinder={true}
                        productFinderServicesUpAndRunning={true}
                        filterContentViewModel={null}
                        globalState={null} l10n={this.props.l10n}
                        productFinderKey={'ESPP1-' + this.props.productFinderPageProps.finderType + 'Web'}
                    />
                    <PfStickyHeader isEsApp={isEsApp} isGlobal={isGlobal} renderNLP={!isMobile}
                                    gridRef={this.gridRef}
                                    nlpIsVisibleByParentRules={isNewsLetterVisible}>
                        <FragmentPlaceholder
                            src={`/ESPP.Breadcrumb/breadcrumb?pageType=${finderType}
                            &containerId=ats_pfr_main_breadCrumb`}
                            ignoreErrors={true}
                            timeout={2}/>
                    </PfStickyHeader>
                    {isMobile &&
                        <PfStickyHeaderMobile isEsApp={isEsApp} isGlobal={isGlobal} gridRef={this.gridRef}>
                            <FragmentPlaceholder
                                src={`/ESPP.Breadcrumb/breadcrumb?pageType=${finderType}
                            &containerId=ats_pfr_mobile_breadCrumb`}
                                ignoreErrors={true}
                                timeout={2}/>
                        </PfStickyHeaderMobile>
                    }
                    <PfArticleTileGrid
                        viewType={viewType}
                        finderType={finderType}
                        isMobile={isMobile}
                        isGlobal={isGlobal}
                        scoredProducts={scoredProducts}
                        l10n={this.props.l10n}
                        priceMode={priceMode}
                        gridRef={this.gridRef}
                    />
                </div>
            </ArticleTileContextProvider>
        );
    }
}
